import React from 'react';
import './PageTitle.scss';
import { sanitizedHTML } from '../../utils/Helper';
import { isHtmlTitle } from '../../utils/UtilsClass';

const PageTitle = (props) => {
  const { title, isFirst, pageTitleWrapperStyle, link } = props;

  return (
    <div
      className={`page-title-wrapper ${isFirst ? '' : 'non-first'}`}
      style={pageTitleWrapperStyle}
    >
      <div
        className={isHtmlTitle(title) ? 'h-page-title' : 'page-title'}
        dangerouslySetInnerHTML={{
          __html: sanitizedHTML(link ? `<a href=${link}>${title}</a>` : title),
        }}
      />
    </div>
  );
};

export default PageTitle;
